import { RepeatableRequestManager } from '@cian/valuation-utils-component';

export let AnalyticsPaymentStatusUpdateService: RepeatableRequestManager;

export const initUpdatePaymentStatusService = () => {
  AnalyticsPaymentStatusUpdateService = new RepeatableRequestManager();
};
